
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Popover";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Popover__root","content":"wds_1_76_1_Popover__content","arrow":"wds_1_76_1_Popover__arrow","element":"wds_1_76_1_Popover__element","animationEnter":"wds_1_76_1_Popover__animationEnter","animationEnterActive":"wds_1_76_1_Popover__animationEnterActive","animationExit":"wds_1_76_1_Popover__animationExit","animationExitActive":"wds_1_76_1_Popover__animationExitActive"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"contentArrowSize":"8px"}; 
export var vars = {}; 




